import { ContactScreen } from '@src/components/screens/ContactScreen'

export default ContactScreen
